import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2SocioTodos } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import * as SocioCrud from 'services/socio.service'

const SocioFormGroup = ({
  idSocioSeleccionado,
  setIdSocioSeleccionado,
  documentoSocioSeleccionado,
  setDocumentoSocioSeleccionado,
  nombreSocioSeleccionado,
  setNombreSocioSeleccionado
}) => {
  const onChangeCliente = clienteEscogido => {
    SocioCrud.obtenerxIdAsInfoSlim(clienteEscogido.value).then(({ data }) => {
      setIdSocioSeleccionado(clienteEscogido.value)
      setDocumentoSocioSeleccionado(data.numeroDocumento)
      setNombreSocioSeleccionado(data.razonSocial)
    })
  }

  const clickClear = React.useCallback(() => {
    setIdSocioSeleccionado('')
    setDocumentoSocioSeleccionado('')
    setNombreSocioSeleccionado('')
  }, [setIdSocioSeleccionado, setDocumentoSocioSeleccionado, setNombreSocioSeleccionado])

  return (
    <Form.Group>
      <Form.Label text='SOCIO' htmlFor='select-cliente' md={2} alignRightAt='md' />
      <Col md={10}>
        {idSocioSeleccionado ? (
          <ClearInputGroup id='codigoRucSocio' iValue={`${documentoSocioSeleccionado} - ${nombreSocioSeleccionado}`} clickClear={clickClear} />
        ) : (
          <Select2SocioTodos id='codigoRucSelect' onChange={onChangeCliente} />
        )}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SocioFormGroup)
